import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { Directive, Component, ChangeDetectionStrategy, ContentChildren, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';

/** This directive defines a header row within the `<nx-header>` component. */
const _c0 = [[["nx-header-row"]], "*"];
const _c1 = ["nx-header-row", "*"];
const _c2 = ["*"];
const _c3 = ["nxHeaderLink", ""];
class NxHeaderRowDirective {
  static {
    this.ɵfac = function NxHeaderRowDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderRowDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxHeaderRowDirective,
      selectors: [["nx-header-row"]],
      hostAttrs: [1, "nx-header__row"],
      exportAs: ["NxHeaderRow"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderRowDirective, [{
    type: Directive,
    args: [{
      selector: 'nx-header-row',
      exportAs: 'NxHeaderRow',
      host: {
        class: 'nx-header__row'
      },
      standalone: true
    }]
  }], null, null);
})();
/** The `<nx-header>` component is the main application header. */
class NxHeaderComponent {
  static {
    this.ɵfac = function NxHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxHeaderComponent,
      selectors: [["nx-header"], ["", "nx-header", ""]],
      contentQueries: function NxHeaderComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NxHeaderRowDirective, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._headerRows = _t);
        }
      },
      hostAttrs: [1, "nx-header"],
      hostVars: 2,
      hostBindings: function NxHeaderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("nx-header--single-row", ctx._headerRows.length === 0);
        }
      },
      ngContentSelectors: _c1,
      decls: 2,
      vars: 0,
      template: function NxHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0);
          i0.ɵɵprojection(0);
          i0.ɵɵprojection(1, 1);
        }
      },
      styles: ["[_nghost-%COMP%]{font-size:var(--header-font-size);line-height:var(--header-line-height);font-weight:var(--header-font-weight);letter-spacing:var(--header-letter-spacing)}.nx-header[_nghost-%COMP%]:not(.nx-header--single-row){display:flex;flex-direction:column}.nx-header.nx-header--single-row[_nghost-%COMP%],   .nx-header__row{display:flex;align-items:center;padding:1px 32px 0;border-bottom:1px solid var(--header-border-color);height:64px;justify-content:space-between;background:var(--header-background-color)}@media screen and (forced-colors: active){.nx-header.nx-header--single-row[_nghost-%COMP%],   .nx-header__row{background-color:Canvas}}@media screen and (max-width: 703px){.nx-header.nx-header--single-row[_nghost-%COMP%],   .nx-header__row{padding:1px 16px 0}}  .nx-header__link{border-bottom:4px solid transparent;padding-top:4px;text-decoration:none;display:block;margin-right:32px;white-space:nowrap}[dir=rtl][_nghost-%COMP%]     .nx-header__link, [dir=rtl]   [_nghost-%COMP%]     .nx-header__link{margin-right:initial;margin-left:32px}  .nx-header__link:after{display:block;content:attr(text-content);font-weight:var(--header-link-active-font-weight);height:1px;overflow:hidden;visibility:hidden}  .nx-header__link.is-active{color:var(--header-link-active-color);border-color:currentColor}  .nx-header__link.is-active .nx-header__link-title{font-weight:var(--header-link-active-font-weight)}  .nx-header__link:hover,   .nx-header__link:active{color:var(--header-link-active-color);border-color:var(--header-link-active-color)}@media screen and (forced-colors: active){  .nx-header__link{color:LinkText!important}}@media screen and (forced-colors: active){  .nx-header__link{border-bottom:none}  .nx-header__link.is-active{border-bottom:4px solid}}  .nx-header__link-title{line-height:0}  .nx-header__brand{margin-right:32px;display:flex;align-items:stretch}[dir=rtl][_nghost-%COMP%]     .nx-header__brand, [dir=rtl]   [_nghost-%COMP%]     .nx-header__brand{margin-right:initial;margin-left:32px}  .nx-header__actions{display:flex;align-items:center;margin-left:24px}  .nx-header__actions.nx-header__actions--show-separator{padding-left:16px;border-left-width:1px;border-left-style:solid;border-left-color:var(--header-border-color)}[dir=rtl][_nghost-%COMP%]     .nx-header__actions, [dir=rtl]   [_nghost-%COMP%]     .nx-header__actions{margin-right:24px;margin-left:initial}[dir=rtl][_nghost-%COMP%]     .nx-header__actions.nx-header__actions--show-separator, [dir=rtl]   [_nghost-%COMP%]     .nx-header__actions.nx-header__actions--show-separator{padding-right:16px;padding-left:initial;border-right-width:1px;border-right-style:solid;border-right-color:var(--header-border-color);border-left:none}  .nx-header__link.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow);border-radius:4px}@media screen and (forced-colors: active),(forced-colors: active){  .nx-header__link.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}[_nghost-%COMP%]     a:focus{outline:none}  .nx-header__app-title{display:flex;font-size:16px;font-weight:700;align-items:center;padding-left:16px;margin-left:16px;white-space:nowrap;border-left-width:1px;border-left-style:solid;border-left-color:var(--header-border-color)}[dir=rtl][_nghost-%COMP%]     .nx-header__app-title, [dir=rtl]   [_nghost-%COMP%]     .nx-header__app-title{padding-right:16px;padding-left:initial;margin-right:16px;margin-left:initial;border-right-width:1px;border-right-style:solid;border-right-color:var(--header-border-color);border-left:none}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'nx-header, [nx-header]',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        class: 'nx-header',
        '[class.nx-header--single-row]': '_headerRows.length === 0'
      },
      standalone: true,
      template: "<ng-content select=\"nx-header-row\"></ng-content>\n<ng-content></ng-content>\n",
      styles: [":host{font-size:var(--header-font-size);line-height:var(--header-line-height);font-weight:var(--header-font-weight);letter-spacing:var(--header-letter-spacing)}:host(.nx-header:not(.nx-header--single-row)){display:flex;flex-direction:column}:host(.nx-header.nx-header--single-row),::ng-deep .nx-header__row{display:flex;align-items:center;padding:1px 32px 0;border-bottom:1px solid var(--header-border-color);height:64px;justify-content:space-between;background:var(--header-background-color)}@media screen and (forced-colors: active){:host(.nx-header.nx-header--single-row),::ng-deep .nx-header__row{background-color:Canvas}}@media screen and (max-width: 703px){:host(.nx-header.nx-header--single-row),::ng-deep .nx-header__row{padding:1px 16px 0}}::ng-deep .nx-header__link{border-bottom:4px solid transparent;padding-top:4px;text-decoration:none;display:block;margin-right:32px;white-space:nowrap}:host-context([dir=rtl]) ::ng-deep .nx-header__link{margin-right:initial;margin-left:32px}::ng-deep .nx-header__link:after{display:block;content:attr(text-content);font-weight:var(--header-link-active-font-weight);height:1px;overflow:hidden;visibility:hidden}::ng-deep .nx-header__link.is-active{color:var(--header-link-active-color);border-color:currentColor}::ng-deep .nx-header__link.is-active .nx-header__link-title{font-weight:var(--header-link-active-font-weight)}::ng-deep .nx-header__link:hover,::ng-deep .nx-header__link:active{color:var(--header-link-active-color);border-color:var(--header-link-active-color)}@media screen and (forced-colors: active){::ng-deep .nx-header__link{color:LinkText!important}}@media screen and (forced-colors: active){::ng-deep .nx-header__link{border-bottom:none}::ng-deep .nx-header__link.is-active{border-bottom:4px solid}}::ng-deep .nx-header__link-title{line-height:0}::ng-deep .nx-header__brand{margin-right:32px;display:flex;align-items:stretch}:host-context([dir=rtl]) ::ng-deep .nx-header__brand{margin-right:initial;margin-left:32px}::ng-deep .nx-header__actions{display:flex;align-items:center;margin-left:24px}::ng-deep .nx-header__actions.nx-header__actions--show-separator{padding-left:16px;border-left-width:1px;border-left-style:solid;border-left-color:var(--header-border-color)}:host-context([dir=rtl]) ::ng-deep .nx-header__actions{margin-right:24px;margin-left:initial}:host-context([dir=rtl]) ::ng-deep .nx-header__actions.nx-header__actions--show-separator{padding-right:16px;padding-left:initial;border-right-width:1px;border-right-style:solid;border-right-color:var(--header-border-color);border-left:none}::ng-deep .nx-header__link.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow);border-radius:4px}@media screen and (forced-colors: active),(forced-colors: active){::ng-deep .nx-header__link.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}:host ::ng-deep a:focus{outline:none}::ng-deep .nx-header__app-title{display:flex;font-size:16px;font-weight:700;align-items:center;padding-left:16px;margin-left:16px;white-space:nowrap;border-left-width:1px;border-left-style:solid;border-left-color:var(--header-border-color)}:host-context([dir=rtl]) ::ng-deep .nx-header__app-title{padding-right:16px;padding-left:initial;margin-right:16px;margin-left:initial;border-right-width:1px;border-right-style:solid;border-right-color:var(--header-border-color);border-left:none}\n"]
    }]
  }], null, {
    _headerRows: [{
      type: ContentChildren,
      args: [NxHeaderRowDirective]
    }]
  });
})();
/** This directive defines the header brand section within the `<nx-header>` component. */
class NxHeaderBrandDirective {
  static {
    this.ɵfac = function NxHeaderBrandDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderBrandDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxHeaderBrandDirective,
      selectors: [["nx-header-brand"]],
      hostAttrs: [1, "nx-header__brand"],
      exportAs: ["NxHeaderBrand"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderBrandDirective, [{
    type: Directive,
    args: [{
      selector: 'nx-header-brand',
      exportAs: 'NxHeaderBrand',
      host: {
        class: 'nx-header__brand'
      },
      standalone: true
    }]
  }], null, null);
})();
/** This directive defines the header actions section within the `<nx-header>` component. */
class NxHeaderActionsDirective {
  constructor() {
    this._showSeparator = false;
  }
  /* Whenever to show the left separator*/
  set showSeparator(value) {
    this._showSeparator = coerceBooleanProperty(value);
  }
  get showSeparator() {
    return this._showSeparator;
  }
  static {
    this.ɵfac = function NxHeaderActionsDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderActionsDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxHeaderActionsDirective,
      selectors: [["nx-header-actions"]],
      hostAttrs: [1, "nx-header__actions"],
      hostVars: 2,
      hostBindings: function NxHeaderActionsDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("nx-header__actions--show-separator", ctx.showSeparator);
        }
      },
      inputs: {
        showSeparator: "showSeparator"
      },
      exportAs: ["NxHeaderActions"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderActionsDirective, [{
    type: Directive,
    args: [{
      selector: 'nx-header-actions',
      exportAs: 'NxHeaderActions',
      host: {
        class: 'nx-header__actions',
        '[class.nx-header__actions--show-separator]': 'showSeparator'
      },
      standalone: true
    }]
  }], null, {
    showSeparator: [{
      type: Input
    }]
  });
})();
/** This component defines the header navigation section within the `<nx-header>` component. */
class NxHeaderNavigationComponent {
  static {
    this.ɵfac = function NxHeaderNavigationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderNavigationComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxHeaderNavigationComponent,
      selectors: [["nx-header-navigation"]],
      hostAttrs: ["role", "navigation", 1, "nx-header__navigation"],
      exportAs: ["NxHeaderNavigation"],
      ngContentSelectors: _c2,
      decls: 2,
      vars: 0,
      consts: [["role", "list", 1, "nx-header__navigation-items"]],
      template: function NxHeaderNavigationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: [".nx-header__navigation[_nghost-%COMP%]{flex:1 1 auto}.nx-header__navigation-items[_ngcontent-%COMP%]{display:flex}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderNavigationComponent, [{
    type: Component,
    args: [{
      selector: 'nx-header-navigation',
      exportAs: 'NxHeaderNavigation',
      host: {
        class: 'nx-header__navigation',
        role: 'navigation'
      },
      template: '<div role="list" class="nx-header__navigation-items"><ng-content></ng-content></div>',
      standalone: true,
      styles: [":host(.nx-header__navigation){flex:1 1 auto}.nx-header__navigation-items{display:flex}\n"]
    }]
  }], null, null);
})();
/** This directive defines a header navigation item within the `<nx-header-navigation>`. */
class NxHeaderNavigationItemDirective {
  static {
    this.ɵfac = function NxHeaderNavigationItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderNavigationItemDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxHeaderNavigationItemDirective,
      selectors: [["nx-header-navigation-item"]],
      hostAttrs: ["role", "listitem", 1, "nx-header__navigation-item"],
      exportAs: ["NxHeaderNavigation"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderNavigationItemDirective, [{
    type: Directive,
    args: [{
      selector: 'nx-header-navigation-item',
      exportAs: 'NxHeaderNavigation',
      host: {
        role: 'listitem',
        class: 'nx-header__navigation-item'
      },
      standalone: true
    }]
  }], null, null);
})();
/** This component defines a header link within the `<nx-header>` component. */
class NxHeaderLinkComponent {
  constructor(_elementRef, _focusMonitor) {
    this._elementRef = _elementRef;
    this._focusMonitor = _focusMonitor;
  }
  ngAfterViewInit() {
    this._focusMonitor.monitor(this._elementRef);
  }
  ngOnDestroy() {
    this._focusMonitor.stopMonitoring(this._elementRef);
  }
  get textContent() {
    return this._elementRef.nativeElement.textContent;
  }
  static {
    this.ɵfac = function NxHeaderLinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderLinkComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.FocusMonitor));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxHeaderLinkComponent,
      selectors: [["a", "nxHeaderLink", ""]],
      hostAttrs: [1, "nx-header__link"],
      hostVars: 1,
      hostBindings: function NxHeaderLinkComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("text-content", ctx.textContent);
        }
      },
      exportAs: ["NxHeaderLink"],
      attrs: _c3,
      ngContentSelectors: _c2,
      decls: 2,
      vars: 0,
      consts: [[1, "nx-header__link-title"]],
      template: function NxHeaderLinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderLinkComponent, [{
    type: Component,
    args: [{
      selector: 'a[nxHeaderLink]',
      exportAs: 'NxHeaderLink',
      host: {
        class: 'nx-header__link',
        '[attr.text-content]': 'textContent'
      },
      template: '<span class="nx-header__link-title"><ng-content></ng-content></span>',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1.FocusMonitor
  }], null);
})();
/** This directive defines the application title within the `<nx-header>` component. */
class NxHeaderAppTitleDirective {
  static {
    this.ɵfac = function NxHeaderAppTitleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderAppTitleDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxHeaderAppTitleDirective,
      selectors: [["nx-header-app-title"]],
      hostAttrs: [1, "nx-header__app-title"],
      exportAs: ["NxHeaderAppTitle"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderAppTitleDirective, [{
    type: Directive,
    args: [{
      selector: 'nx-header-app-title',
      exportAs: 'NxHeaderAppTitle',
      host: {
        class: 'nx-header__app-title'
      },
      standalone: true
    }]
  }], null, null);
})();
const EXPORTS = [NxHeaderComponent, NxHeaderLinkComponent, NxHeaderActionsDirective, NxHeaderNavigationComponent, NxHeaderBrandDirective, NxHeaderRowDirective, NxHeaderNavigationItemDirective, NxHeaderAppTitleDirective];
class NxHeaderModule {
  static {
    this.ɵfac = function NxHeaderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxHeaderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NxHeaderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxHeaderModule, [{
    type: NgModule,
    args: [{
      exports: EXPORTS,
      imports: [CommonModule, ...EXPORTS]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NxHeaderActionsDirective, NxHeaderAppTitleDirective, NxHeaderBrandDirective, NxHeaderComponent, NxHeaderLinkComponent, NxHeaderModule, NxHeaderNavigationComponent, NxHeaderNavigationItemDirective, NxHeaderRowDirective };
